<section class="logo-container flex col a-center">
    @if (customSvg) {
        <svg class="logo-container" [outerHTML]="customSvg"></svg>
    } @else {
        <svg class="icon-avg" x="0px" y="0px" viewBox="0 0 131.7 49.9">
            <g>
                <path
                    fill="currentColor"
                    d="M128.3,24.6c-0.1-0.9,0.6-1.8,1.5-1.8l0,0c1.3,0,2-1.7,1.1-2.7l-4.2-4.5c-0.1-0.1-0.3-0.2-0.6-0.1l-20.2,5.8
    c-0.2,0.1-0.4,0.3-0.4,0.6v27.3c0,0.3,0.2,0.7,0.6,0.7h25c0.3,0,0.7-0.3,0.6-0.7L128.3,24.6z"
                />
            </g>
            <path
                fill="currentColor"
                d="M102.7,49.2V7.6c0-0.6-0.4-0.9-1-0.8l-16.3,4.6c-0.3,0.1-0.6,0.3-0.6,0.7L81.7,49c0,0.4,0.3,0.9,0.8,0.9h19.4
    C102.3,50,102.7,49.5,102.7,49.2z"
            />
            <path
                fill="currentColor"
                d="M55.5,50c0,0-3.6,0-3.6-3.7L48.7,3.7c0,0,0-3.7,3.6-3.7h26.9c0,0,3.6,0,3.6,3.7l-3.2,42.5c0,0,0,3.7-3.6,3.7
    L55.5,50z"
            />
            <g>
                <path
                    fill="currentColor"
                    d="M2.8,24.6c0.1-0.9-0.6-1.8-1.5-1.8l0,0c-1.3,0-2-1.7-1.1-2.7l4.2-4.5c0.1-0.1,0.3-0.2,0.6-0.1l20.2,5.8
    c0.2,0.1,0.4,0.3,0.4,0.6v27.3c0,0.3-0.2,0.7-0.6,0.7H0c-0.3,0-0.7-0.3-0.6-0.7L2.8,24.6z"
                />
            </g>
            <path
                fill="currentColor"
                d="M28.5,49.2V7.6c0-0.6,0.4-0.9,1-0.8l16.3,4.6c0.3,0.1,0.6,0.3,0.6,0.7L49.5,49c0,0.4-0.3,0.9-0.8,0.9H29.3
    C28.8,50,28.5,49.5,28.5,49.2z"
            />
        </svg>
    }
</section>
